/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.19.0
 * @since 1.0.0
 */

import { IPageHistoryOrderTranslation } from '../../types';

const initTranslationPageHistoryOrder: IPageHistoryOrderTranslation = {
    table: {
        action: {
            header: '',
            placeholder: '',
        },
        date: {
            header: '',
        },
        files: {
            header: '',
        },
        status: {
            header: '',
            placeholder: '',
        },
        subsCount: {
            header: '',
        },
        user: {
            header: '',
        },
    },
    title: {
        dropFilters: '',
        export: '',
        label: '',
    },
};

export default initTranslationPageHistoryOrder;
